"use client"

import { useEffect, useRef, useState } from "react"
import { usePathname } from "next/navigation"
import Script from "next/script"

type PixelWindow = Window & {
  fbq?: (command: "trackSingle", pixelId: string, event: "PageView") => void
}

/** Track full loads and App Router navigation without duplicate mount events. */
export function MetaPixel({ pixelId }: { pixelId: string }) {
  const pathname = usePathname()
  const [ready, setReady] = useState(false)
  const lastPage = useRef<string | null>(null)
  const validId = /^[1-9]\d*$/.test(pixelId)

  useEffect(() => {
    if (!validId || !ready || !pathname) return
    const pixel = (window as PixelWindow).fbq
    if (!pixel) return
    const page = `${pixelId}:${pathname}`
    if (lastPage.current === page) return
    pixel("trackSingle", pixelId, "PageView")
    lastPage.current = page
  }, [validId, ready, pathname, pixelId])

  if (!validId) return null

  return (
    <Script
      id={`meta-pixel-${pixelId}`}
      strategy="afterInteractive"
      onReady={() => setReady(true)}
    >
      {`
        !function(f,b,e,v,n,t,s){
          if(f.fbq)return;n=f.fbq=function(){
            n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)
          };
          if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
          t=b.createElement(e);t.async=!0;t.src=v;
          s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)
        }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${pixelId}');
      `}
    </Script>
  )
}
